import { type PreParsedSectionItemsSettingProps, type PreParsedSectionSettingProps } from '@capsicum/common';
import { useMemo } from 'react';

import { useSetSectionActions } from './useSetSectionActions';

const filterItems = (items: Array<PreParsedSectionItemsSettingProps>) =>
	items.filter(item => item.link || item.element || item.onPress);

export const useFilterSections = (sections: Array<PreParsedSectionSettingProps>) => {
	const sectionsWithActions = useSetSectionActions(sections);

	return useMemo(
		() =>
			sectionsWithActions
				.map(section => ({
					items: filterItems(section.items),
					key: section.key,
					title: section.title
				}))
				.filter(section => section.items.length > 0),

		[sectionsWithActions]
	);
};
